<template>
  <div class="app-container bj-label-colon">
    <BjDivider
      >基础信息
      <template v-slot:button>
        <el-button type="primary" class="xs" @click="$refs.dialogList.show()">选择逻辑仓</el-button>
      </template>

      <template v-slot:right>
        <el-button @click="tryCancel">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="handleConfirm('form')">{{ $t('saveText') }}</el-button>
      </template>
    </BjDivider>

    <el-form label-width="130px" style="width: 600px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="预留锁定单号">
            <span class="tips">系统自动生成</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="仓库编码">
            {{ info.code }}
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="仓库名称">
            {{ info.name }}
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('table.remarkText')">
            <BjInput
              v-model="info.remark"
              :maxlength="MAX_LENGTH.DEFAULT"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              :placeholder="$t('inputText')"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <BjDivider
      >商品明细
      <template v-slot:button>
        <el-button :disabled="!info.code" type="primary" class="xs" @click="dialogListGoodsShow()"
          >选择商品</el-button
        >

        <el-button
          :disabled="selectedRow.length == 0"
          type="primary"
          class="xs"
          @click="onDelSelected()"
          >删除商品</el-button
        >
      </template></BjDivider
    >
    <el-table
      ref="multipleTable"
      :data="tableData"
      stripe
      border
      :header-cell-style="$rowStyle.DEFAULT"
      row-key="BJ_EBC_ID"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column type="index" width="55" align="center" label="序号" />
      <el-table-column prop="categoryName" label="商品分类" />
      <el-table-column prop="spuCode" label="商品编码" />
      <el-table-column prop="spuName" label="商品名称" />
      <el-table-column prop="skuCode" label="SKU编码" />

      <el-table-column prop="usableNum" label="可预留库存">
        <template slot-scope="props">
          {{ props.row.usableNum || props.row.realityNum || 0 }}
        </template>
      </el-table-column>
      <el-table-column prop="planNum" label="预计预留数量">
        <template slot-scope="props">
          <BjInput v-model="props.row.planNum" :maxlength="MAX_LENGTH.DEFAULT" />
        </template>
      </el-table-column>
    </el-table>

    <BjDialogList
      ref="dialogList"
      :config="$BjDialogListConfig.stockWarehouseLogic()"
      @confirm="onConfirmDialogList"
    />
    <BjDialogList
      ref="dialogListGoods"
      :config="dialogListConfigGoods"
      multiple
      row-keys="skuCode"
      @confirm="onConfirmDialogListGoods"
    />
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { stockApi } from '@/api';

export default {
  name: 'BusinessStockLockAdd',
  mixins: [viewMiXin],
  data() {
    return {
      info: {
        name: null,
        code: null,
        remark: null,
      },

      tableData: [],

      selectedRow: [],
    };
  },
  computed: {
    dialogListConfigGoods() {
      return this.$BjDialogListConfig.stockGoodsDefault('选择商品', {
        defaultQuery: { warehouseCode: this.info.code },
      });
    },
  },
  methods: {
    dialogListGoodsShow() {
      this.$refs.dialogListGoods.show();
    },
    handleSelectionChange(d) {
      this.selectedRow = [].concat(d);
    },
    // 获取info
    onConfirmDialogList(data) {
      this.info.id = data[0].id;
      this.info.code = data[0].code;
      this.info.name = data[0].name;
    },
    onConfirmDialogListGoods(data) {
      data.forEach(row => {
        const FLAG = this.tableData.find(e => e.skuCode == row.skuCode);
        if (!FLAG) {
          this.tableData.push({ ...row, planNum: null });
        }
      });
    },

    onDelSelected() {
      this.selectedRow.forEach(row => {
        this.tableData.splice(
          this.tableData.findIndex(e => e.skuCode == row.skuCode),
          1,
        );
      });
      // 清除选中状态
      this.$refs.multipleTable.clearSelection();
    },
    reFresh() {
      this.$emit('reFresh');
    },
    handleConfirm(formName) {
      if (!this.info || !this.info.id || !this.info.code) {
        this.$message.warning('请先选择仓库');
        return;
      }

      if (this.tableData.length == 0) {
        this.$message.warning('请先选择商品');
        return;
      }

      const one = this.tableData.find(e => (e.usableNum || e.realityNum || 0) < e.planNum);
      if (one) {
        this.$message.warning(
          `${one.spuName} （ ${one.skuCode} ） 的 预计预留数量 超过了 可预留库存`,
        );
        return;
      }
      const two = this.tableData.find(e => !e.planNum || e.planNum <= 0);
      if (two) {
        this.$message.warning(`${two.spuName} （ ${two.skuCode} ）的 预计预留数量 需要大于0`);
        return;
      }
      const API_DATA = {
        // reserveCode: 'string',
        reserveDetailReqDTOList: this.tableData.map(e => {
          return {
            num: e.planNum,
            skuCode: e.skuCode,
            tenantId: this.$store.getters.tenantId,
          };
        }),
        // id: 0,
        remark: this.info.remark,
        warehouseCode: this.info.code,
        warehouseId: this.info.id,
      };

      this.addApi(API_DATA);
    },
    addApi(API_DATA) {
      stockApi.addReserveRecords(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.complete('BusinessStockLockIndex');
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
